import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  questionWithMediaContainer: {
    width: '100%',
  },
  titleContainer: {
    width: '100%',
    alignSelf: 'flex-start',
  },
  questionText: {
    color: theme.palette.common.black,
  },
  serverError: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
  serverErrorIcon: {
    color: theme.palette.common.red600,
    fontSize: theme.spacing(2),
    flexShrink: 0,
    marginTop: theme.spacing(0.25),
  },
  required: {
    '&:after': {
      color: theme.palette.common.red400,
      content: "' *'",
    },
  },
  mediaWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  questionImageContainer: {
    width: '100%',
    maxWidth: 240,
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    '&:hover $fullscreenButton': {
      opacity: 1,
    },
  },
  questionImageImg: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: 320,
  },
  fullscreenButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderRadius: '50%',
    minWidth: 'unset',
    width: theme.spacing(4),
    height: theme.spacing(4),
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
    '& svg': {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: theme.palette.common.white,
    },
  },
  fullscreenContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: theme.zIndex.modal,
  },
  imageWrapper: {
    position: 'relative',
    maxWidth: '90vw',
    maxHeight: '90vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  previewImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '90vw',
    maxHeight: '90vh',
    objectFit: 'contain',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(3),
    right: theme.spacing(3),
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: '50%',
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
    '& svg': {
      width: 28,
      height: 28,
    },
  },
  loaderContainer: {
    minHeight: 240,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
}));
